import { render, staticRenderFns } from "./mobileNews.vue?vue&type=template&id=ef1d2de2&scoped=true&"
import script from "./mobileNews.vue?vue&type=script&lang=js&"
export * from "./mobileNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1d2de2",
  null
  
)

export default component.exports